export default __webpack_public_path__ + "static/media/lupo-sports.590f8163.png";